import template from './RuleItemView.html';
import { RuleItemController } from './RuleItemController';
export const NewRuleItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: RuleItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        teams: '<',
        application: '<',
        canEditRule: '<',
        canSeeRule: '<',
        operators: '<',
        properties: '<',
        relations: '<',
        onDelete: '&?',
        onCancel: '&?',
        close: '&?',
        source: '<',
        onChangeStatus: '&?',
        elementId: '@?',
        onSave: '&?',
        onToggle: '&?',
        isManagerView: '<',
        isQueueManagementView: '<',
        isBuilderView: '<',
        currentState: '<',
        onOpenRule: '&?',
        isAnyRuleOpen: '&?',
    },
};
